export default __webpack_public_path__ + "static/media/user_brooke.8ca77fe8.png";